var map = {
	"./adult/nn/wordchain-tutorial": 776,
	"./adult/no/wordchain-tutorial": 777,
	"./child/de/wordchain-tutorial": 106,
	"./youth/de/wordchain-tutorial": 778,
	"./youth/nn/wordchain-tutorial": 779,
	"./youth/no/wordchain-tutorial": 780,
	"./youth/se/wordchain-tutorial": 781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 775;